import { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { ErrorBoundary } from '../components/ErrorBoundary'
import { AdminConfigSidebar } from './AdminConfigSidebar'
import { Topbar } from './Topbar'

const SIDEBAR_KEY = 'walleon-sidebar-collapsed'

function readCollapsed(): boolean {
  try {
    return localStorage.getItem(SIDEBAR_KEY) === '1'
  } catch {
    return false
  }
}

/** Mesmo esqueleto do Shell normal, mas com o menu de configurações no lugar do menu do app. */
export function AdminConfigShell() {
  const location = useLocation()
  const [collapsed, setCollapsed] = useState(readCollapsed)
  const [mobileOpen, setMobileOpen] = useState(false)

  function toggleSidebar() {
    if (window.matchMedia('(max-width: 1023px)').matches) {
      setMobileOpen((v) => !v)
      return
    }
    setCollapsed((v) => {
      try { localStorage.setItem(SIDEBAR_KEY, v ? '0' : '1') } catch { /* storage unavailable */ }
      return !v
    })
  }

  return (
    <div className="flex h-full bg-bg">
      <AdminConfigSidebar collapsed={collapsed} mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />

      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Topbar onToggleSidebar={toggleSidebar} />

        <main className="flex flex-1 flex-col overflow-y-auto">
          <div className="flex-1 p-6">
            <ErrorBoundary key={location.pathname}>
              <Outlet />
            </ErrorBoundary>
          </div>
          <footer className="flex flex-wrap items-center justify-between gap-2 border-t border-border/60 px-6 py-5 text-13 text-muted">
            <span>{new Date().getFullYear()} © Walleon.</span>
            <span>Painel administrativo.</span>
          </footer>
        </main>
      </div>
    </div>
  )
}
